import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { fetchDataHandler, fetchNavigation } from '@/lib/fetcher';
import HeadMetaTag from '@/components/metatags/HeadMetaTag';
import React from 'react';
import OfertaIndex from '@/features/oferta/OfertaIndex/OfertaIndex';
import CustomError from '@/features/errors';
import AppProvider from '@/context/AppProvider';

export const getStaticProps: GetStaticProps = async () => {
  const path = `/ofertas`;
  const [navigation, pageProps] = await Promise.all([fetchNavigation(), fetchDataHandler(path, 'OFERTAS INDEX')]);
  const { props, notFound, redirect } = pageProps;
  if (notFound !== undefined) return { notFound: true };
  if (redirect !== undefined) return { redirect };
  if (props !== undefined) return { props: { ...props, navigation }, revalidate: 30 };

  return {
    props: {
      data: null,
    },
  };
};

export default function Ofertas({ data, error, ...props }: InferGetStaticPropsType<typeof getStaticProps>) {
  if (error) {
    return <CustomError error={error} />;
  }
  const { meta } = data;
  return (
    <AppProvider navigation={...props.navigation}>
      <HeadMetaTag meta={meta} />
      <OfertaIndex data={data} />
    </AppProvider>
  );
}
